import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GLOBAL } from './global';
import { TokenService } from '../services/token.service';

@Injectable()
export class CybersecurityCreditService {

  constructor(
    public http: HttpClient,
    private _tokenService:TokenService) {}

  urlAbout = `${GLOBAL.url}/cybersecurity/credit`;
  headers = new HttpHeaders()

  saveCredit(credit:object){
    let params = JSON.stringify(credit);
    let token = this._tokenService.getToken();
    const HEADERS = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    })
    return this.http.post(this.urlAbout, params, { headers: HEADERS })
  }

  getCredits(){
    return this.http.get(this.urlAbout, {headers: this.headers})
  }

}
